import Vue from 'vue'

Vue.filter('capitalize', (value) => {
  if (!value) {
    return ''
  }
  value = value.toString()
  if (value.includes('-')) {
    const newItem = value.split('-')
    return newItem[0].charAt(0).toUpperCase() + newItem[0].slice(1) + ' ' + newItem[1].charAt(0).toUpperCase() + newItem[1].slice(1)
  }
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('priceAbbreviated', (number, fraction = 2) => {
  const ranges = [
    { divider: 1, suffix: '' },
    { divider: 1e3, suffix: ' هزار' },
    { divider: 1e6, suffix: ' میلیون' },
    { divider: 1e9, suffix: ' میلیارد' },
    { divider: 1e12, suffix: ' تریلیون' },
    { divider: 1e15, suffix: ' کوآدریلیون' },
    { divider: 1e18, suffix: ' کوینتیلیون' }
  ]
  // find index based on number of zeros
  const len = Math.floor(number).toFixed().toString().length
  const index = Math.floor((len / 3))
  return (number / ranges[index].divider).toFixed(2) + ranges[index].suffix
})

Vue.filter('formatPrice', (num) => {
  if (num >= 1000000000000) {
    return (num / 1000000000000).toFixed(1).replace(/\.0$/, '') + ' تریلیون'
  } else if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + ' میلیارد'
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + ' میلیون'
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + ' هزار'
  } else {
    return num.toString()
  }
})

Vue.filter('coinSeparator', (amount) => {
  switch (true) {
    case (amount === 0):
      return 0

    case (amount < 0.0001):
      return Number(amount).toFixed(8)

    case (amount < 1):
      return Number(amount).toFixed(6)

    case (amount <= 1000):
      return Number(amount).toFixed(2)

    case (amount > 1000):
      return Number(Number(amount).toFixed(0)).toLocaleString()

    default :
      return Number(Number(amount).toFixed(2)).toLocaleString()
  }
})

Vue.filter('tomanSeparator', (amount) => {
  switch (true) {
    case (amount === 0):
      return 0

    case (amount < 1):
      return Number(amount).toFixed(3)

    case (amount >= 1):
      return Number(Number(amount).toFixed(0)).toLocaleString()
  }
})

Vue.filter('nameAbbreviated', (name) => {
  switch (true) {
    case (name.length < 16):
      return name

    case (name.length >= 16):
      return name.substring(0, 12) + '..'
  }
})
